// extracted by mini-css-extract-plugin
module.exports = {"Demo":"demo-module--Demo--3Mv2B","Demo__container":"demo-module--Demo__container--2LTAz"};